import React from 'react';
import SearchBar from '@fiverr-private/search_bar/src';
import I18n from '@fiverr-private/fiverr_context/src/I18n';
import I18nProvider from '@fiverr-private/fiverr_context/src/I18nProvider';
import getSubCategoryUrl from '../../../utils/url';
import { popularSearches, reportBi, BI_TYPE_TAGS } from './config';

import './style.scss';

const TAG_SOURCE = 'hplo_search_tag';

const Header = () => (
    <div className="header">
        <h1><I18n k="logged_out_homepage.hero.title"/></h1>
        <I18nProvider>
            {({ i18n }) => {
                const searchBarParams = {
                    placeholder: i18n.t('logged_out_homepage.hero.logo_animation'),
                    source: 'main_banner'
                };

                return (
                    <SearchBar {...searchBarParams}/>
                );
            }}
        </I18nProvider>
        <div className="popular">
            <span className="text-body-2"><I18n k="logged_out_homepage.hero.popular"/></span>
            <ul>
                {
                    popularSearches.map((item, index) => {
                        const pos = index + 1;
                        const subCatParams = {source: TAG_SOURCE, pos, name: item.subCategorySlug};
                        const tagPath = getSubCategoryUrl(item.categorySlug, item.subCategorySlug, subCatParams);

                        return (
                            <li key={index}>
                                <a href={tagPath}
                                    className="text-body-2"
                                    onClick={() => reportBi(BI_TYPE_TAGS, {position: pos, ...item})}>
                                    {item.name}
                                </a>
                            </li>
                        );
                    })
                }
            </ul>
        </div>
    </div>
);

export default Header;
